import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { IconClose, IconSearch, InputField } from '@noths/polaris-client-ribbons-design-system';
import { ICON_BUTTON_TEXT_CLASS, iconButton } from '@noths/polaris-client-styles';
import * as styles from "./SearchField.styles";
export var SearchField = function SearchField(_ref) {
  var ariaAutocomplete = _ref.ariaAutocomplete,
    ariaExpanded = _ref.ariaExpanded,
    ariaOwns = _ref.ariaOwns,
    displayValue = _ref.displayValue,
    id = _ref.id,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onKeyDown = _ref.onKeyDown,
    onReset = _ref.onReset,
    placeholder = _ref.placeholder,
    showSubmitButtonAsFocused = _ref.showSubmitButtonAsFocused,
    value = _ref.value;
  var inputRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isValid = _useState2[0],
    setIsValid = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasFocus = _useState4[0],
    setHasFocus = _useState4[1];
  var handleFocus = useCallback(function (evt) {
    setHasFocus(true);
    onFocus === null || onFocus === void 0 || onFocus(evt);
  }, [onFocus]);
  var handleBlur = useCallback(function (evt) {
    setHasFocus(false);
    onBlur === null || onBlur === void 0 || onBlur(evt);
  }, [onBlur]);
  var onResetInput = useCallback(function () {
    if (inputRef.current) {
      inputRef.current.focus();
    }
    onReset();
  }, [onReset]);
  useEffect(function () {
    setIsValid(!!value.trim().length);
  }, [value]);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.searchFieldContainer
  }, /*#__PURE__*/React.createElement(InputField, {
    "aria-autocomplete": ariaAutocomplete,
    "aria-expanded": ariaExpanded,
    "aria-owns": ariaOwns,
    autoComplete: "off",
    id: id,
    label: "Search",
    labelHidden: true,
    onBlur: handleBlur,
    onChange: onChange,
    onFocus: handleFocus,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    ref: inputRef,
    role: "combobox",
    type: "text",
    value: displayValue || value
  }), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: styles.buttonContainer
  }, value && /*#__PURE__*/React.createElement(_StyledButton, {
    "data-testid": "clear",
    onClick: onResetInput,
    type: "reset",
    $_css3: [iconButton, styles.clear]
  }, /*#__PURE__*/React.createElement(_StyledIconClose, {
    $_css4: styles.icon
  }), /*#__PURE__*/React.createElement("span", {
    className: ICON_BUTTON_TEXT_CLASS
  }, "clear")), /*#__PURE__*/React.createElement(_StyledButton2, {
    disabled: !isValid,
    type: "submit",
    $_css5: [iconButton, styles.submit, (hasFocus || showSubmitButtonAsFocused) && styles.focusSearchIconSubmit]
  }, /*#__PURE__*/React.createElement(_StyledIconSearch, {
    $_css6: styles.icon
  }), /*#__PURE__*/React.createElement("span", {
    className: ICON_BUTTON_TEXT_CLASS
  }, "search"))));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledButton = _styled3("button")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledIconClose = _styled4(IconClose)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledButton2 = _styled5("button")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledIconSearch = /*#__PURE__*/_styled6(IconSearch).withConfig({
  displayName: "SearchField___StyledIconSearch",
  componentId: "sc-1qi3oh7-0"
})(["", ""], function (p) {
  return p.$_css6;
});